<div class="user-status text-small" *ngIf="!!user && user.id" (mouseenter)="mouseEnter()" (mouseleave)="mouseLeave()">
  <div class="text-center d-flex align-items-center" [routerLink]="['/user']">
    <div class="avatar">
      <img src="{{ user.avatarPath  +'?w=110&h=110&mode=crop' | safeResource}}" *ngIf="user.avatarPath"
        class="hoverable" />
      <div class="badge" *ngIf="user.officalUp">
        <img src="{{'./assets/images/officalUp.png?v=10'|absUrl}}">
      </div>
    </div>
  </div>
  <ng-container *ngTemplateOutlet="myCard"></ng-container>
</div>
<div class="user-status text-small text-left" *ngIf="!user || !user.id" (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()">
  <div class="text-center d-flex align-items-center" (click)="login()" title="登录/注册">
    <div class="avatar not-login">
      <img class="hoverable" src="{{'./assets/images/logon.png?v=2' | absUrl}}" alt="默认头像" />
    </div>
    <span class="nickname lh-40 text-right">登录</span>

  </div>
  <ng-container *ngTemplateOutlet="myCard"></ng-container>
</div>

<ng-template #myCard>
  <app-mycard (hideMyCardEvent)="hideMyCard()" [hide]="!expand"></app-mycard>
</ng-template>